import ReactGA from 'react-ga';

const useGAEventTracker = (category = "") => {
    const trackEvent = (action = "", label = "") => {
        ReactGA.event({category: category, action: action, label: label});
    };

    return trackEvent;
};

export default useGAEventTracker;